import React, { useState, useEffect, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';

import DateFilter from 'components/dateFilter';
import PDFHeader from 'components/pdf/header';
import PDFFooter from 'components/pdf/footer';
import FooterNote from 'components/footer/footerNote';
import InsightsLoader from 'components/loaders/InsightsLoader';
import TotalLearners from 'pages/insights/containers/learnersAnalyticsContainer/components/totalLearners';
import DownloadLearnersAnalytics from 'pages/insights/containers/learnersAnalyticsContainer/components/downloadLearnerAnalytics';
import LearnersOverview from 'pages/insights/containers/learnersAnalyticsContainer/components/learnersOverview';
import LearnersMAUs from 'pages/insights/containers/learnersAnalyticsContainer/components/learnersMAUs';
import LearnersCourseCompletions from 'pages/insights/containers/learnersAnalyticsContainer/components/learnersCourseCompletions';
import LearnersAnalyticsSummary from 'pages/insights/containers/learnersAnalyticsContainer/components/learnersAnalyticsSummary';
import { analyticsSummaryActions } from 'pages/insights/containers/analyticsSummaryContainer/actions';
import { learnersAnalyticsActions } from 'pages/insights/containers/learnersAnalyticsContainer/actions';
import { getLearnerUsersInfo, getCurrentLearnerCourseCompletions } from 'selectors';

const moment = require('moment');

const LearnersAnalytics = (props) => {
  const { learners_count, learners_data, current_page, dispatch } = props;

  const defaultState = {
    filter_type: 'this_year',
    filter_start_date: moment().subtract(1, 'months'),
    filter_end_date: moment()
  };

  const [learnerFilterType, setLearnerFilterType] = useState(defaultState.filter_type);
  const [learnerFilterStartDate, setLearnerFilterStartDate] = useState(defaultState.filter_start_date);
  const [learnerFilterEndDate, setLearnerFilterEndDate] = useState(defaultState.filter_end_date);

  useEffect(() => {
    dispatch(learnersAnalyticsActions.fetchUsersDetailAnalytics({ page: 1, learners_only: 'true' }));
    dispatch(
      learnersAnalyticsActions.fetchLearnersMAUs({
        filter_type: learnerFilterType,
        filter_start_date: learnerFilterStartDate,
        filter_end_date: learnerFilterEndDate
      })
    );
    dispatch(
      learnersAnalyticsActions.fetchLearnersCourseCompletions({
        filter_type: learnerFilterType,
        filter_start_date: learnerFilterStartDate,
        filter_end_date: learnerFilterEndDate
      })
    );
    dispatch(
      analyticsSummaryActions.fetchSiteDailyMetrics({
        filter_type: learnerFilterType,
        filter_start_date: learnerFilterStartDate,
        filter_end_date: learnerFilterEndDate
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const handleFilterChange = (value) => {
    setLearnerFilterType(value);
  };

  const handleSetStartDate = (date) => {
    setLearnerFilterStartDate(date);
  };

  const handleSetEndDate = (date) => {
    setLearnerFilterEndDate(date);
  };

  const handleRefresh = (e) => {
    e.preventDefault();
    dispatch(
      learnersAnalyticsActions.fetchLearnersCourseCompletions({
        filter_type: learnerFilterType,
        filter_start_date: learnerFilterStartDate,
        filter_end_date: learnerFilterEndDate
      })
    );

    dispatch(
      learnersAnalyticsActions.fetchLearnersMAUs({
        filter_type: learnerFilterType,
        filter_start_date: learnerFilterStartDate,
        filter_end_date: learnerFilterEndDate
      })
    );
  };

  const setDefaultFilter = (e) => {
    e.preventDefault();
    setLearnerFilterType(defaultState.filter_type);
    dispatch(learnersAnalyticsActions.fetchLearnersCourseCompletions(defaultState));
    dispatch(learnersAnalyticsActions.fetchLearnersMAUs(defaultState));
  };

  return (
    <div id="page_content" className="learners-analytics">
      <PDFHeader />
      <div className="page-content-header">
        <h2>Learner Analytics</h2>
        <DownloadLearnersAnalytics dispatch={dispatch} />
      </div>

      <LearnersAnalyticsSummary />

      <div className="stats-block">
        <TotalLearners />
      </div>

      <div className="mb-3 stats-block">
        <DateFilter
          filterType={learnerFilterType}
          handleRefresh={handleRefresh}
          handleFilterChange={handleFilterChange}
          handleSetStartDate={handleSetStartDate}
          handleSetEndDate={handleSetEndDate}
          setDefaultFilter={setDefaultFilter}
        />
      </div>

      <Row className="stats-block">
        <Col xs="12" lg="6">
          <LearnersMAUs show_chart="true" />
        </Col>
        <Col xs="12" lg="6">
          <LearnersCourseCompletions show_chart="true" />
        </Col>
      </Row>

      <LearnersOverview
        dispatch={dispatch}
        learners_count={learners_count}
        current_page={current_page}
        learners_data={learners_data}
      />

      <FooterNote />
      <PDFFooter />
    </div>
  );
};

function mapStateToProps(state) {
  const current_course_completions = getCurrentLearnerCourseCompletions(state);
  const { learners_count, learners_data, current_page } = getLearnerUsersInfo(state);

  return {
    current_course_completions,
    learners_count,
    learners_data,
    current_page
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    ...bindActionCreators(learnersAnalyticsActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LearnersAnalytics);
